import React from 'react';
import CustomModal from '../../../../components/generic/custommodal/CustomModal';
import FormsListComponent from './FormsListComponent';
import SecondaryButton from '../../../../components/generic/buttons/SecondaryButton';

const ModalFormsListComponent = ({isModalOpen, closeModal, onFooterButtonClicked, formStatuses}) => {

    const footerButtonsForForms = (
        <div>
            <SecondaryButton buttonText="Cancel" handleOnClick={onFooterButtonClicked} />
        </div>
    )

    return (
        <CustomModal
            isModalOpen={isModalOpen}
            footer={footerButtonsForForms}
            closable={false}
            closeModal={closeModal}
        >
            <FormsListComponent formStatuses={formStatuses} />
        </CustomModal>
    );
};

export default ModalFormsListComponent;
